import * as api from '../rubblemaster_openapi3_typescript-fetch/';
import { AccessLevel } from '../types';
import flagEnUs from '../assets/icons/en-US.png';
import flagEnGb from '../assets/icons/en-GB.png';
import flagDeAt from '../assets/icons/de-AT.png';
import flagEsEs from '../assets/icons/es-ES.png';
import flagFrFr from '../assets/icons/fr-FR.png';
import flagItIt from '../assets/icons/it-IT.png';

export const rubbleMasterHq = {
  lat: +48.254022,
  lng: +14.379771,
};

export const basePath =
  process.env.NODE_ENV === 'production'
    ? window.location.protocol + '//' + window.location.host
    : 'https://localhost:44306';

export const machinesApi = new api.MachinesApi(
  new api.Configuration({ basePath: basePath, credentials: 'include' })
);
export const machineUserSettingsApi = new api.MachineUserSettingsApi(
  new api.Configuration({ basePath: basePath, credentials: 'include' })
);
export const fetchStatusApi = new api.StatesApi(
  new api.Configuration({ basePath: basePath, credentials: 'include' })
);
export const fetchTagsApi = new api.TagsApi(
  new api.Configuration({ basePath: basePath, credentials: 'include' })
);
export const machineTagsApi = new api.MachineTagsApi(
  new api.Configuration({ basePath: basePath, credentials: 'include' })
);
export const fetchSessionApi = new api.SessionApi(
  new api.Configuration({ basePath: basePath, credentials: 'include' })
);
export const userApi = new api.UsersApi(
  new api.Configuration({ basePath: basePath, credentials: 'include' })
);

export const uploadApi = new api.UploadApi(
  new api.Configuration({ basePath: basePath })
);


// Injected at build time from the pipeline variable REACT_APP_GOOGLE_MAPS_API_KEY.
// This value is PUBLIC by design: Create React App inlines it into the JavaScript
// bundle, so every visitor receives it. Its protection is the HTTP referrer
// restriction and the daily quota cap configured on the key in Google Cloud —
// never secrecy. Do NOT reuse this key server-side; the API has its own
// IP-restricted key under GoogleMapsService:GoogleMapsApiKey.
export const googleApiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY || '';

if (!googleApiKey) {
  // eslint-disable-next-line no-console
  console.warn(
    'REACT_APP_GOOGLE_MAPS_API_KEY is not set. Maps and geocoding will not work. ' +
      'Set it as a build-time variable in the pipeline, or in Frontend/.env.local for local development.'
  );
}
// ACHTUNG: hier KEIN async! Führt zu F5-Problem
//export const googleMapUrlWithKey = `https://maps.googleapis.com/maps/api/js?key=${googleApiKey}&loading=async`;
export const googleMapUrlWithKey = `https://maps.googleapis.com/maps/api/js?key=${googleApiKey}`;
// Geocode only through the Maps JavaScript API (helpers/geocoder.tsx). The
// Geocoding web service (maps/api/geocode/json) rejects this key, because the
// key has a website restriction.

// The linking domains are subdomains. Rewrite is handled on backend.
export const openLinkWithRewrite = (route: string) => {
  console.log("In openLinkWithRewrite : " + route)
  window.location.href = route;
};

export const initialMachineState = {
  id: 0,
  serialNumber: '',
  notes: '',
  owner: '',
  machineTypeId: 0,
  isDeactivated: false,
  isHybrid: false,
  spsProgramVersion: '',
  displayProgramVersion: '',
  state: {
    id: 0,
    key: '',
  },
  stateText: '',
  projectConstructionSite: '',
  hasWeightData : false,
  allowLocationList: false,
  useBlacklist : false,
  errorBlackList: '',
  machineType: {
    id: 0,
    name: '',
    category: '',
  },
  maintenanceInfo: null,
  currentlyAuthenticatedUserAccessLevel: AccessLevel.None,
  info: '',
  logInfo: '',
};

export const languageOptions: { isoLanguageString: string; img: string }[] = [
  {
    isoLanguageString: 'en-GB',
    img: flagEnGb,
  },
  {
    isoLanguageString: 'en-US',
    img: flagEnUs,
  },
  {
    isoLanguageString: 'de-AT',
    img: flagDeAt,
  },
  {
    isoLanguageString: 'es-ES',
    img: flagEsEs,
  },
  {
    isoLanguageString: 'fr-FR',
    img: flagFrFr,
  },
  {
    isoLanguageString: 'it-IT',
    img: flagItIt,
  },
];

export const sensorInterval = {
  ignitionKeyOn: 60,
  engineFuelRate: 60,
  operatingMode: 900,
  percentLoad: 60,
  jawPressure: 60,
  machineType: 60,
  machineSerialNo: 60,
  gpsLatitude: 60,
  gpsLongitude: 60,
  workingHoursIgnitionOn: 900,
  workingMinutesIgnitionOn: 900,
  workingSecondsIgnitionOn: 900,
  workingMilliSecondsIgnitionOn: 900,
  rmErrorMsg: 900,
  gpsSpeed: 900,
  gpsAccuracy: 900,
  crusherEngineSpeedIst: 60,
  crusherEngineSpeedSoll: 60,
  engineWorkingHoursH: 900,
  engineWorkingHoursMin: 900,
  engineWorkingHoursSec: 900,
  fuelLevel: 900,
  adBlueLevel: 900,
  temperatureCrusherEngine: 900,
  currentLoadCrusherDrive: 60,
  intermediateCircuitVoltage: 60,
  weigher1CurrentDisplayed: 60,
  weigher2CurrentDisplayed: 60,
  weigher3CurrentDisplayed: 60,
  weigher4CurrentDisplayed: 60,
};

export type PerformanceIndicatorLevel = 'idle' | 'low' | 'medium' | 'high';
export const performanceIndicatorDefinitions: { [key in PerformanceIndicatorLevel]: string } = {
  high: '>= 75%',
  medium: '>= 50% < 75%',
  low: '>= 25% < 50%',
  idle: '< 25%',
};

